import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import useScrollTriggerRefresh from '../../hooks/useScrollTriggerRefresh';

function Layout({ children }) {
    const location = useLocation();

    // Création d'une variable CSS pour la largeur des colonnes
    // Mise à jour à chaque changement d'URL et en prenant en considération le redimensionnement de la page
    useEffect(() => {
        let timeout;
        let delay = 100;

        const updateColumnWidth = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                let columnRef = document.getElementById("grid-proof").querySelector(".desktop-visible.mobile-visible:not(.grid--marge)");
                if (columnRef) {
                    const columnWidth = columnRef?.offsetWidth || 100;
                    document.body.style.setProperty("--column-width", `${columnWidth}px`);
                }
            }, delay);
        };

        // Exécuter une première fois la fonction au chargement de la page
        updateColumnWidth();

        // Mise en place de l'écouteur d'événement pour le resize de la page
        window.addEventListener("resize", updateColumnWidth);

        // Nettoyage de l'écouteur d'événement et du timer
        return () => {
            clearTimeout(timeout);
            window.removeEventListener("resize", updateColumnWidth);
        };
    }, [location.pathname]);

    // On appelle notre hook pour le rafraichissement de ScrollTrigger
    useScrollTriggerRefresh();

    return <>{children}</>;
}

Layout.propTypes = {
    children: PropTypes.element.isRequired
}

export default Layout;
